import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../images/hrp-small-use-logo-white.svg';

export default function Footer() {
  const todaysDate = new Date();

  const backToTopClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="text-center bg-light">
        <button
          type="button"
          className="btn btn-dark mb-3"
          onClick={backToTopClick}
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      </div>

      <div className="bg-dark mt-auto">
        <div className="container text-center text-white py-3">
          <p className="mt-3">
            <a href="https://www.hrp.org.uk/" className="text-white mx-2">
              Visit HRP website
            </a>

            <a
              href="https://www.hrp.org.uk/membership/"
              className="text-white mx-2"
            >
              Join as a member
            </a>

            <span className="footlinks__link ot-sdk-show-settings text-white mx-2">
              Manage Cookies
            </span>

            <a
              href="https://www.hrp.org.uk/sponsor-a-stone-faqs/"
              className="text-white mx-2"
            >
              FAQ
            </a>
          </p>

          <img src={logo} width="200" alt="HRP Logo" />

          <p>
            Copyright © Historic Royal Palaces {todaysDate.getFullYear()}
            <br />
            Historic Royal Palaces is a Registered Charity (No. 1068852)
          </p>
        </div>
      </div>
    </>
  );
}